export const SERVER_SOCKET_EVENTS = {
  LOGIN: 'login',
  SET_USERNAME: 'set username',
  CHAT_MESSAGE: 'chat message'
};

export const CLIENT_SOCKET_EVENTS = {
  CHAT_MESSAGE: 'chat message',
  CONNECTED_VALID: 'connected_valid'
};
